import { APICore } from './apiCore';

const api = new APICore();

export const createApiCall = (baseUrl, buildQueryParams) => {
    return (endpoint, query) => {
        const normalizedEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;

        if (typeof query === 'string') {
            const querySuffix = query ? `?${query}` : '';
            return api.get(`${baseUrl}${normalizedEndpoint}${querySuffix}`, {}, {});
        }

        const params = buildQueryParams ? buildQueryParams(query) : {};
        return api.get(`${baseUrl}${normalizedEndpoint}`, params || {}, {});
    };
};

